module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2mrM9"))).then(() => module.bundle.root('ljYL6'));